import { FC, useEffect, useRef, useState } from "react";
import { Col, Modal, Row, Tag, Typography } from "antd";
import moment from "moment";
import {
  BodyElementsWrapper,
  ContentWrapper,
  GlobalModalStyles,
  MessagesWrapper,
  TitleWrapper,
} from "./styled";
import { ChatHistory, ChatInput } from "../Chat";
import { ActionsBlock } from "./ActionsBlock";
import { CommentModalBodyElement } from "./CommentModalBodyElement";
import {
  ConditionalTooltipText,
  ScrollableWrapper,
  ShowMoreText,
  StyledTag,
} from "../../components";
import { commentsTabs } from "../../constants";
import { TCommentData, TCommentsTab } from "../../types";
// import { markNotificationReaded, syncMessageHistory } from "services";
// import { useCentrifugeChats } from "../../hooks";

interface ICommentModalProps {
  comment: TCommentData;
  onCancel: () => void;
  refreshComments: () => void;
  status: TCommentsTab;
}

const pickTagByCommentStatus = {
  [commentsTabs[0]]: {
    color: "#595959",
    tagColor: "#f5f5f5",
    title: "В работе",
  },
  [commentsTabs[1]]: {
    color: "#1677ff",
    tagColor: "#e6f4ff",
    title: "Отправлено в ПИ",
  },
  [commentsTabs[2]]: {
    color: "#f5222d",
    tagColor: "#fff1f0",
    title: "Отклонено",
  },
  [commentsTabs[3]]: {
    color: "#52c41a",
    tagColor: "#f6ffed",
    title: "Отработано",
  },
};

export const CommentModal: FC<ICommentModalProps> = ({
  comment,
  onCancel,
  refreshComments,
  status,
}) => {
  const [isVisible, setVisible] = useState(!!comment);

  const isChatSynced = useRef(false);

  // const [chatMessages, isLoading, isConnected] = useCentrifugeChats(
  //   comment.partnersChatId
  // );

  const handleCancel = () => {
    setVisible(false);

    setTimeout(() => {
      onCancel();
    }, 200);
  };

  // useEffect(() => {
  //   if (comment.partnersChatId && isConnected && !isChatSynced.current) {
  //     syncMessageHistory(comment.partnersChatId, moment());
  //     isChatSynced.current = true;
  //   }
  // }, [isConnected]);

  // useEffect(() => {
  //   if (!isLoading && comment.partnersChatId) {
  //     const lastMessageId = chatMessages.at(-1)?.message_id;

  //     lastMessageId && markNotificationReaded({ chat: comment.partnersChatId });
  //   }
  // }, [isLoading]);

  return (
    <>
      <GlobalModalStyles />

      <Modal
        className="comment-modal"
        title={
          <TitleWrapper>
            <Typography.Text strong>{comment.title}</Typography.Text>

            <StyledTag
              $textColor={pickTagByCommentStatus[status].color}
              color={pickTagByCommentStatus[status].tagColor}
            >
              {pickTagByCommentStatus[status].title}
            </StyledTag>
          </TitleWrapper>
        }
        // visible={isVisible}
        onCancel={handleCancel}
        footer={null}
        width={720}
        centered
      >
        <ContentWrapper>
          <Col className="info-block">
            <Col>
              <BodyElementsWrapper>
                <CommentModalBodyElement
                  description={
                    <Row
                      align="middle"
                      className="content-info-header"
                      wrap={false}
                    >
                      <Col span={6}>
                        <Tag color={"#e6f4ff"}>{comment.number}</Tag>
                      </Col>

                      <Col span={18}>
                        <ConditionalTooltipText
                          className="project-name"
                          text={comment.project.name}
                          withoutBreaks
                        />
                      </Col>
                    </Row>
                  }
                  title="№"
                />

                <CommentModalBodyElement
                  description={comment.kitName}
                  title="Комплект"
                />

                <CommentModalBodyElement
                  description={comment.documentation.name}
                  title="Том"
                />

                <CommentModalBodyElement
                  description={
                    <ScrollableWrapper maxHeight={196}>
                      <ShowMoreText rows={4} text={comment.description} />
                    </ScrollableWrapper>
                  }
                  title="Замечание"
                />

                {status === commentsTabs[2] && comment.descriptionDecision && (
                  <CommentModalBodyElement
                    description={comment.descriptionDecision}
                    title="Решение"
                  />
                )}
              </BodyElementsWrapper>
            </Col>

            <ActionsBlock
              comment={comment}
              onAfterClick={() => {
                refreshComments();
                onCancel();
              }}
              status={status}
            />
          </Col>

          <Col className="chat-block">
            <MessagesWrapper>
              <ChatHistory
                isContractorsChat
                isLoading={false
                  // isLoading
                }
                messages={[{created_at: "string",
                message_id: 23,
                text: "sdsdsd",
                user_id: 33,
                full_name: "ddsdd",
                role: "sddds"},{created_at: "strindddg",
                message_id: 233,
                text: "sdsdsd",
                user_id: 323,
                full_name: "ddsddfdfd",
                role: "sdsssdds"}]}
              />
            </MessagesWrapper>

            <ChatInput
              chatId={comment.partnersChatId}
              disabled={status !== commentsTabs[0]}
            />
          </Col>
        </ContentWrapper>
      </Modal>
    </>
  );
};
